import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { hmLightTheme } from "../themes/hmTheme";

const normalizeDateValue = (rawValue: unknown): string => {
  if (rawValue === "today" || rawValue == null) {
    return dayjs().format("YYYY-MM-DD");
  }
  if (rawValue === "no" || rawValue === "") {
    return "";
  }
  const parsed = dayjs(String(rawValue));
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
};

export default function CustomSlots({ ...props }) {
  const { value, id, name, required, onChange, onBlur } = props;
  const [inputValue, setInputValue] = useState<string>(
    normalizeDateValue(value)
  );
  const [error, setError] = useState(props?.error);

  useEffect(() => {
    setInputValue(normalizeDateValue(value));
  }, [value]);

  useEffect(() => {
    setError(Boolean(props?.error));
  }, [props?.error]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.value;
    setInputValue(nextValue);
    onChange && onChange(nextValue);
  };

  const handleBlur = () => {
    if (required) {
      if (inputValue === "") {
        setError(true);
      } else {
        setError(false);
      }
    } else {
      setError(false);
    }

    if (onBlur) {
      onBlur();
    }
  };

  return (
    <TextField
      id={id}
      name={name}
      type="date"
      value={inputValue}
      variant="outlined"
      fullWidth
      color="secondary"
      className="dateText"
      required={required}
      error={error}
      onChange={handleChange}
      onBlur={handleBlur}
      InputLabelProps={{ shrink: true }}
      sx={{
        "& input": {
          pl: "14px",
          fontFamily: hmLightTheme?.palette?.numberFontFamily,
        },
      }}
    />
  );
}
